var script = {
  name: 'PendoPage',
  inject: ['$app'],
  props: {
    backgroundColor: {
      type: String,
      default() {
        return this.$app.pageBackgroundColor;
      }
    }
  },
  computed: {
    pageClasses() {
      return {
        'pendo-page--tabs': this.$app.tabs
      };
    },
    pageStyle() {
      const sidebarWidth = parseInt(this.$app.sidebarWidth);
      const topbarHeight = parseInt(this.$app.topbarHeight);
      return {
        background: this.backgroundColor,
        position: 'fixed',
        top: `${topbarHeight}px`,
        right: '0px',
        height: `calc(100% - ${topbarHeight}px)`,
        overflowY: 'auto',
        overflowX: 'auto',
        minWidth: '0px',
        left: `${sidebarWidth}px`
      };
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-page.vue2.js.map
